import { z } from 'zod';
import { BaseErrorSchema } from '../../shared/error.schema';
import { ProcessStepRecordingSchema } from '../../entities/process-step-recording';
import { ObjectIdSchema } from '../../shared/object-id.schema';
import { ProcessStepAssignmentStatusSchema } from '../../entities/process-step-assignment/process-step-assignment.schema';
/**
 * Show Process Step Recording Request Schema
 * GET /api/v2/process-step-recording/:id
 * Step recording ID provided as URL parameter
 */ export const ShowProcessStepRecordingRequestSchema = z.void();
/**
 * Pending placeholder body returned when no recording exists but an open
 * `ProcessStepAssignment` owns the stable step id. Clients render a waiting
 * state instead of 404-ing the page.
 */ export const PendingStepRecordingSchema = z.object({
    status: z.literal('pending'),
    assignmentId: ObjectIdSchema,
    assignmentStatus: ProcessStepAssignmentStatusSchema,
    stableStepId: ObjectIdSchema
});
/**
 * Show Process Step Recording Response Schema
 * Returned on successful retrieval
 * Contains the requested process step recording object with IDs (minimal population)
 * Uses minimal schema since this endpoint is used by the recording page which needs IDs for forms
 */ export const ShowProcessStepRecordingResponseSchema = z.union([
    z.object({
        processStepRecording: ProcessStepRecordingSchema
    }),
    z.object({
        pending: PendingStepRecordingSchema
    })
]);
/**
 * Show Process Step Recording Error Schema
 * Returned when retrieval fails
 */ export const ShowProcessStepRecordingErrorSchema = BaseErrorSchema;

//# sourceMappingURL=show-process-step-recording.schema.js.map